import React, { useState } from 'react';

import axios from 'axios';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { red } from '@mui/material/colors';

import { Button, Stack, Typography } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';

export default function InvoicePayedRow({ invoice, accounts }) {

    const VAT_RATES = {
        NOR: '20 %',
        MID: '10 %',
        RED: '5,5 %',
        SPE: '2,1 %',
        NUL: '0 %',
        ND: 'indéterminé',
    };

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell component="th" scope="row">{new Date(invoice.date_send).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' }).replace('.', '')}</TableCell>
                <TableCell align="left">
                    {accounts.find((acc) => acc.id === invoice.account)?.full_name || "Compte introuvable"}
                </TableCell>
                <TableCell>{invoice.number}</TableCell>
                <TableCell align="right">
                    <Typography variant='body1'>{invoice.total_amount.toLocaleString('fr-FR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}</Typography>
                </TableCell>
            </TableRow>
        </>
    );
};